<script>
export default {
	props: {
		name: {
			type: String,
			default: ''
		}
	},
	watch: {
		show(value) {
			if (value) {
				this.focusModal();
			}
			this.$emit('modalChanged', { name: this.name, isOpened: value });
		}
	},
	mounted() {
		if (this.show) {
			this.focusModal();
			this.$emit('modalChanged', { name: this.name, isOpened: this.show });
		}
	},
	methods: {
		focusModal() {
			setTimeout(() => {
				if (this.$refs.modal) {
					this.$refs.modal.$el.focus();
				}
			});
		}
	}
};
</script>
